import { useSo5Competitions } from '#src/hooks/useSo5Competitions.ts';

export const useCompetitionEligibilityFilterValue = (
  competitionEligibilityFilter: string | undefined
) => {
  const { filterableSo5Competitions } = useSo5Competitions();

  if (!competitionEligibilityFilter || !filterableSo5Competitions) return null;

  return filterableSo5Competitions.find(
    s => s.slug === competitionEligibilityFilter
  )?.algoliaFilters;
};
